import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Radio, CheckIcon, Loader, Text, Select } from '@mantine/core'
import { getAllSupplierList } from '../../../../../services/supplier'
import { getAllWarehouseList } from '../../../../../services/warehouse'
import { useDebouncedCallback } from '@mantine/hooks'
import { updatePackageShipment } from '../../../../../services/package'
import { validation } from '../../../../../plugins/validation'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'

const formValidation = {
  selectedHandlingId: {
    isError: false,
    message: ''
  },
}

const FormAdjustHandleShipment = ({ dataHandleShipment, onCloseForm, reloadList }) => {
  const [selectedHandling, setSelectedHandling] = useState('supplier')
  const [selectedHandlingId, setSelectedHandlingId] = useState(null)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)
  const [dataList, setDataList] = useState([])
  const [loadingData, setLoadingData] = useState(true)
  const [searchData, setSearchData] = useState('')

  const submitHandlingShipment = async (selected, id) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    const validateForm = {
      selectedHandlingId: id
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    const payload = {
      courier_name_slug: dataHandleShipment.courier_name_slug,
      tracking_code: dataHandleShipment.tracking_code,
      last_mile_courier: dataHandleShipment.last_mile_courier,
      tracking_code_courier: dataHandleShipment.tracking_code_courier,
      estimated_arrival: dataHandleShipment.estimated_arrival,
      estimated_departure: dataHandleShipment.estimated_departure,
      port_of_landing: dataHandleShipment.port_of_landing,
      port_of_destination: dataHandleShipment.port_of_destination,
      order_id: dataHandleShipment.order_id
    }
    if (selected === 'supplier') {
      payload.supplier_id = Number(id)
      payload.warehouse_id = null
    } else {
      payload.supplier_id = null
      payload.warehouse_id = Number(id)
    }
    try {
      const response = await updatePackageShipment(dataHandleShipment.id, payload)
      if (response.success) {
        onCloseForm()
        reloadList()
        notificationSuccess('Update Package Shipment Successfully', 'You have been updated data package shipment')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError('Update Package Shipment Error', captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetListData = useDebouncedCallback(async (handling, dataId) => {
    setLoadingData(true)
    const parameter = {
      'filter[id][is]': dataId,
      'filter[name][like]': searchData,
      'page[num]': 1,
      'page[limit]': 10,
    } 
    let methodFunction = null
    if (handling === 'supplier') {
      methodFunction = getAllSupplierList(parameter)
    } else {
      methodFunction = getAllWarehouseList(parameter)
    }
    try {
      const response = await methodFunction
      if (response.success) {
        const dataList = response.data
        const remapData = dataList.map((val) => {
          return {
            value: `${val.attributes.id}`,
            label: val.attributes.name
          }
        })
        setDataList(remapData)
      } else {
        setDataList([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingData(false)
    }
  }, 300)

  useEffect(() => {
    handleGetListData(selectedHandling)
    // eslint-disable-next-line
  }, [searchData])

  useEffect(() => {
    if (dataHandleShipment) {
      if (dataHandleShipment.supplier_id !== null) {
        handleGetListData('supplier', dataHandleShipment.supplier_id)
      }
      if (dataHandleShipment.warehouse_id !== null) {
        handleGetListData('warehouse', dataHandleShipment.warehouse_id)
      }
      if (dataHandleShipment.supplier_id !== null || dataHandleShipment.warehouse_id !== null) {
        handleSetForm(dataHandleShipment)
      }
    }
    // eslint-disable-next-line
  }, [dataHandleShipment])


  useEffect(() => {
    handleGetListData(selectedHandling)
    // eslint-disable-next-line
  }, [selectedHandling])

  const handleSetForm = (val) => {
    const handlingShipment = val.supplier_id !== null ? `supplier` : `warehouse`
    const selectedId = val.supplier_id !== null ? `${val.supplier_id}` : `${val.warehouse_id}`
    setSelectedHandlingId(selectedId)
    setSelectedHandling(handlingShipment)
  }

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  return (
    <Box>
      <Box mb='sm'>
        <Radio.Group
          value={selectedHandling}
          onChange={(val) => [setSelectedHandling(val), setSelectedHandlingId(null)]}
          name="selectedHandling"
          label="Who Handle Shipping ?"
          description=""
          withAsterisk
          size='xs'
          mb={10}
        >
          <Radio icon={CheckIcon} value="supplier" size='xs' my={8} label="Supplier" />
          <Radio icon={CheckIcon} value="warehouse" size='xs' label="Warehouse" />
        </Radio.Group>
      </Box>
      <Box mb='sm'>
        <Select
          name='selectedHandlingId'
          label={`Select ${selectedHandling === 'supplier' ? 'Supplier': 'Warehouse'}`}
          value={selectedHandlingId}
          data={dataList}
          onChange={setSelectedHandlingId}
          size='xs'
          searchable
          searchValue={searchData}
          onSearchChange={setSearchData}
          nothingFoundMessage={!loadingData ? dataList.length > 0 ? '' : 'No Data Found' : loadingDataTemplate()}
          error={validationForm.selectedHandlingId.isError ? `${validationForm.selectedHandlingId.message}` : ''}
          clearable
          allowDeselect={false}
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' variant="filled" loading={loadingForm} onClick={() => submitHandlingShipment(selectedHandling, selectedHandlingId)}>Submit</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustHandleShipment